import React from "react";
import DetailSong from "./DetailSong/DetailSong";
import ListSongs from "./ListSongs/ListSongs";

export default function Content({ setSong }) {
  return (
    <div className="grid grid-cols-3 text-neutral-400 h-screen-navbar">
      {/* col-span-1 */}
      <DetailSong />
      {/* col-span-2 */}
      <ListSongs setSong={setSong} />
    </div>
  );
}
